import modalContentLoaded from '../../helpers/modalContentLoaded';
import OnlineShopperV2 from './onlineShopperV2';
import fetchRequest from "./onlineShopperV2/fetchRequest";
import formatNumbers from '../../helpers/formatNumbers';
import Cookies from "js-cookie";
import Emitter from 'tiny-emitter';
import get from "../../helpers/get";

function onlineShopper() {
    let OS_DATA, OS_MODAL, OSV2, OS_BUTTON, monthlyPayment;
    const emitter = new Emitter();

    emitter.on('new-vdp-monthly-payment', paymentsPromise => {
        updateVdpMonthlyPayments(paymentsPromise);
    });

    try {
        OS_DATA = JSON.parse(document.querySelector('[modal-id="online-shopper-modal"]').dataset.onlineShopperData);
        OS_MODAL = document.querySelector('[modal-id="online-shopper-modal"]');
        OS_BUTTON = document.querySelector('[data-button-name="online-shopper"]');
    } catch (error) {
        OS_DATA = {};
    }

    if (OS_BUTTON && OS_DATA && OS_MODAL && OS_DATA.onlineShopperV2) {
        const dealCookie = `OnlineShopper${OS_DATA.vin}`;
        const savedDeal = Cookies.getJSON(dealCookie);

        OSV2 = new OnlineShopperV2(OS_DATA, OS_MODAL, emitter);

        if (savedDeal && savedDeal.apiBase && savedDeal.uuid && savedDeal.api_key) {
            const dealData = fetchRequest.getDealRevisions(savedDeal);
            emitter.emit('new-vdp-monthly-payment', dealData);
        } else {
            const vdpPayments = fetchRequest.getMonthlyPayments(OS_DATA.onlineShopperSlug, OS_DATA.vin, OS_DATA.onlineShopperApiBase);
            emitter.emit('new-vdp-monthly-payment', vdpPayments);
        }

        OS_BUTTON.addEventListener('click', () => {
            modalContentLoaded('#online-shopper-v2', () => {
                OSV2.init(monthlyPayment);
            });
        });
    }

    async function updateVdpMonthlyPayments(paymentsPromise) {
        const bankContainer = document.querySelectorAll('.online-shopper-v2-payments__bank label');
        const monthlyPrice = document.querySelectorAll('.online-shopper-v2-payments__price h1');
        const financeContainer = document.querySelector('.online-shopper-v2-payments__finance');
        const leaseContainer = document.querySelector('.online-shopper-v2-payments__lease');
        const resolvedPayments = await paymentsPromise;
        const monthlyPaymentInfo = formatPayments(resolvedPayments);

        if (monthlyPaymentInfo.loanAmount) {
            monthlyPrice[0].innerText = `$${formatNumbers(monthlyPaymentInfo.loanAmount, 'money')}`;
            bankContainer[0].innerText = `From ${monthlyPaymentInfo.loanLender}`;
            financeContainer.style.display = 'block';

            if (monthlyPaymentInfo.leaseAmount) {
                monthlyPrice[1].innerText = `$${formatNumbers(monthlyPaymentInfo.leaseAmount, 'money')}`;
                bankContainer[1].innerText = `From ${monthlyPaymentInfo.leaseLender}`;
                leaseContainer.style.display = 'block';
            }
        }
    }

    function formatPayments (resolvedPayments) {
        let leaseValue, loanValue, leaseLenderName, loanLenderName;

        if (resolvedPayments.loan) {
            monthlyPayment = resolvedPayments;
            loanValue = get(resolvedPayments, 'loan.payment');
            leaseValue = get(resolvedPayments, 'lease.payment');
            loanLenderName = get(resolvedPayments, 'loan.lender');
            leaseLenderName = get(resolvedPayments, 'lease.lender');
        } else {
            monthlyPayment = get(resolvedPayments, 'vehicles[0].payments');
            const leaseSelectedOffer = get(resolvedPayments, 'vehicles[0].payments.lease.selected_offer');
            const loanSelectedOffer = get(resolvedPayments, 'vehicles[0].payments.loan.selected_offer');
            leaseValue = get(resolvedPayments, `vehicles[0].payments.lease.offers[${leaseSelectedOffer}].payment`);
            loanValue = get(resolvedPayments, `vehicles[0].payments.loan.offers[${loanSelectedOffer}].payment`);
            leaseLenderName = get(resolvedPayments, `vehicles[0].payments.lease.offers[${leaseSelectedOffer}].lender`);
            loanLenderName = get(resolvedPayments, `vehicles[0].payments.loan.offers[${loanSelectedOffer}].lender`);
        }

        return {
            leaseAmount: leaseValue,
            leaseLender: leaseLenderName,
            loanAmount: loanValue,
            loanLender: loanLenderName
        };
    }
}

export default onlineShopper;